var render = function render(){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('canvas', {
    attrs: {
      "id": _vm.idChart
    }
  });

}
var staticRenderFns = []

export { render, staticRenderFns }